<template>
  <div class="logo-container">
    <img height="126" src="@/assets/img/landing/price/price-logo.png" />
    <div class="logo-content">
      <div class="logo-title">
        신규 사장님을 위한
        <div :style="{ display: this.$vuetify.breakpoint.mdAndUp ? 'none' : 'block' }"></div>
        첫 구독 이벤트!
      </div>
      <div class="logo-subtitle">20% 할인된 가격으로 체험해 보세요</div>
    </div>
    <button @click="handleScrollToLargeBanner" class="logo-button">혜택 자세히 보기</button>
  </div>
</template>

<script>
export default {
  name: 'DesktopLogo',
  methods: {
    handleScrollToLargeBanner() {
      this.$emit('click-scroll-to-large-banner');
    },
  },
};
</script>

<style scoped lang="scss">
.logo-container {
  position: relative;
  width: 100%;
  height: 126px;
  overflow: hidden;
  border-radius: 24px;
}
.logo-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  position: absolute;
  top: 0px;
  height: 100%;

  left: 260px;
  border-radius: 24px;
}

.logo-title {
  color: var(--default-dark-color);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 125% */
}

.logo-subtitle {
  color: #5f5f5f;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}

.logo-button {
  position: absolute;
  top: 42px;
  right: 40px;

  width: 129px;
  height: 44px;
  padding: 12px 16px;
  border-radius: 8px;
  background: var(--default-color);

  // font
  color: #fff;
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>
